import Vue from 'vue'
import { addGA } from '@/utils/assist'
import { updateConsentGA } from '@/utils/eu_popup'

export default new Vue({
  data () {
    return {
      uid: null,
      gems: 0,
      loading: { // loading dialog
        show: false,
        opacity: false
      },
      toast: {
        show: false,
        isMsg: false,
        text: ''
      },
      rule: { // rule dialog
        show: false,
        content: ''
      },
      history: { // history dialog
        show: false,
        data: [] // history 相关数据
      },
      lotteryDialog: {
        show: false,
        notice: true,
        price: 0
      },
      rewardDialog: {
        show: false,
        data: {}
      },
      confirmDialog: {
        show: false,
        type: ''
      },
      firstLoading: true,
      refreshNotice: true, // 付费刷新提示
      flipNotice: true, // 付费翻牌提示
      skipAnime: false, // 跳过动画
      firstLoad: false, // 第一次进入活动
      shuffleAnime: false, // 播放洗牌动画
      flipCards: [],
      flipAnime: false, // 翻牌动画
      flipIdx: null,
      hasFlip: false,
      actInfo: {
        useFreeRefresh: 0, // 使用的免费刷新次数
        allFreeRefresh: 0, // 全部免费刷新次数
        refreshCost: 0, // 付费刷新价格
        spends: [], // 各阶段花费
        canRefresh: true
      },
      nowPrice: 0, // 当前价格
      nowCount: 1,
      rewardPool: [],
      transify: {
        COMMON_BACK: 'back',
        COMMON_CANCEL: 'cancel',
        COMMON_CONFIRM: 'confirm',
        COMMON_CONTINUE_PURCHASE: 'continue to buy',
        COMMON_HISTORY_DRAW: '',
        COMMON_HISTORY_PURCHASE: '',
        COMMON_HISTORY_REDEEM: '',
        COMMON_NO: 'no',
        COMMON_PURCHASE: 'purchase',
        COMMON_PURCHASED: 'purchased',
        COMMON_QUANTITY_MAX: 'max',
        COMMON_TIPS_ITEM: 'the rewards will be sent directly to your vault',
        COMMON_YES: 'Yes',
        POPUP_NO_REMIND: "Don't remind me again",
        POPUP_TITLE_REDEEM: 'Congratulation! You got',
        POPUP_TITLE_UNIQUE: 'The unique items you owe',
        UNIQUE_BUY_ALREADY_HAVE:
          'You already own this item, if you purchase it again, it will be converted to FF tokens.',
        UNIQUE_BUY_ALREADY_HAVE_PART:
          'You already owe some of the item(s) you selected. If you purchase again, you will receive FF tokens instead.',
        UNIQUE_REDEEM_ALREADY_HAVE:
          'You already own this item, if you receive it again, it will be converted to FF tokens.',
        TOAST_ERROR_CODE: 'unknown error, error code {code}',
        TOAST_EVENT_CLOSED_AWHILE: 'The event is closed temporary',
        TOAST_EVENT_END: 'Event ended',
        TOAST_EVENT_NOTOPEN: "event hasn't started",
        TOAST_GEM_NOT_ENOUGH: 'insufficient diamonds, please top up and come back again',
        TOAST_LOGIN_FAILED: 'login failed',
        TOAST_NETWORK_BUSY: 'Server busy, please try again later',
        TOAST_NETWORK_ERROR: 'Network connection error, please try again later',
        TOAST_OPERATE_BUSY: 'Too many requests, please try again later',
        TOAST_PAY_FAILED: 'purchase failed',
        TOAST_SERVER_BUSY: '',
        TOAST_SERVER_NOTWORK: 'service unavailable',
        TOAST_SERVER_TIMEOUT: 'service timeout',
        TOAST_WRONG_REGION: 'This event is not available for your region'
      }
    }
  },
  methods: {
    updateConsentGA,
    checkGem (price) {
      let flag = true
      if (this.gems < price) {
        flag = false
      }
      return flag
    },
    addGA (event, msg) { // google 统计
      addGA(event, msg)
    },
    /**
     * 错误处理
     * @param {String} errCode 错误码
     * @return toast | dialog 组件
     */
    handleError (errCode) {
      // TODO 错误信息提示窗
      this.handleToast(true, errCode, true)
      addGA('msgError', errCode)
    },
    handleToast (bool, text, isMsg = false) { // toast
      this.toast.show = bool
      this.toast.text = this.transify[text] || this.transify['TOAST_NETWORK_ERROR']
      this.toast.isMsg = isMsg
    },
    handleLoading (bool, opacity, delay) { // loading
      if (bool === true) {
        this.loading.opacity = opacity
        this.loading.show = bool
      } else {
        setTimeout(() => {
          this.loading.show = bool
          this.loading.opacity = opacity
          this.firstLoading = false
          if (delay > 0 && !this.skipAnime) { // 进入页面
            !this.hasFlip ? this.shuffleAnime = this.firstLoad : this.shuffleAnime = false
            if (this.firstLoad) {
              this.firstLoad = false
              localStorage.setItem(`${PROJECT_NAME}_load_${this.uid}`, false)
            }
          }
        }, delay)
      }
    },
    randomsort (a, b) {
      return Math.random() > 0.5 ? -1 : 1
    },
    setRewardPool (pool) {
      this.rewardPool = []
      let count = 0
      for (let item of pool) {
        this.rewardPool.push({
          id: item.item_id, // 商品id
          name: item.item_name, // 商品名
          type: item.pool, // 商品池类型
          src: item.item_img, // 图片链接
          status: item.status, // 0 -正常， 1 -已领取
          num: item.item_num,
          index: count++
        })
        if (item.status === 1) {
          this.hasFlip = true
        }
      }
      this.rewardPool = this.rewardPool.sort(this.randomsort) // 排序奖池
      this.initFlipCards()
    },
    setActInfo (userInfo, config) {
      this.actInfo = {
        useFreeRefresh: userInfo.free_refresh_count,
        allFreeRefresh: config.free_refresh_count, // 总免费刷新次数
        refreshCost: config.refresh_cost, // 刷新价格
        spends: [config.flip_1_cost, config.flip_2_cost, config.flip_3_cost], // 各阶段消耗
        canRefresh: userInfo.can_refresh
      }
    },
    getHistory () {
      this.$api.history().then(res => {
        this.history.data = res.data.history
        this.history.show = true
        this.addGA('history', 'show')
      })
    },
    refresh (price) {
      this.$api.refresh({gems: price}).then(res => {
        let rewards = res.data.rewards
        if (price === 0) {
          this.$bus.actInfo.useFreeRefresh++
        }
        this.$bus.actInfo.canRefresh = res.data.can_refresh
        this.gems -= price
        this.setRewardPool(rewards) // 设置奖池
        this.handleToast(true, 'FLIP_TOAST_1') // 提示刷新成功
        this.addGA('refresh', 'success')
        this.shuffleAnime = !this.skipAnime
        this.flipIdx = null
        localStorage.removeItem(`${PROJECT_NAME}_flipIdxs_${this.uid}`)
      })
    },
    flip () {
      this.$api.flip({gems: this.nowPrice, count: this.nowCount}).then(res => {
        this.gems -= this.nowPrice
        this.rewardDialog.data = res.data
        this.addGA('flip', 'success')
        this.keepFlipStatus(res.data) // 保持翻牌状态
      })
    },
    keepFlipStatus (data) {
      const flipIdxs = JSON.parse(localStorage.getItem(`${PROJECT_NAME}_flipIdxs_${this.uid}`)) || {}
      if (Object.keys(flipIdxs).length < 3) {
        let pool = data.pool
        flipIdxs[pool] = this.flipIdx
        let index = this.flipCards.findIndex(item => item.type === data.pool)
        this.flipCards[index].status = 1
        if (index !== this.flipIdx) {
          [
            this.flipCards[index].index,
            this.flipCards[this.flipIdx].index
          ] = [
            this.flipIdx,
            this.flipCards[index].index
          ]
        }
      }
      localStorage.setItem(`${PROJECT_NAME}_flipIdxs_${this.uid}`, JSON.stringify(flipIdxs))
    },
    initFlipCards () {
      this.flipCards = JSON.parse(JSON.stringify(this.rewardPool))
      let flipIdxs = JSON.parse(localStorage.getItem(`${PROJECT_NAME}_flipIdxs_${this.uid}`)) || []
      console.log(flipIdxs)
      const Cards = [] // 存储已经翻过的数组
      const backCards = [] // 存储未翻过的数组
      let indexArr = [0, 1, 2] // 存储未翻过的索引
      for (let item of this.flipCards) {
        let index = flipIdxs[item.type]
        console.log(index)
        if (typeof index === 'undefined') {
          backCards.push(item)
        } else {
          item.index = index
          Cards.push(item)
          indexArr.splice(indexArr.indexOf(flipIdxs[item.type]), 1)
        }
      }
      indexArr.forEach((item, index) => {
        backCards[index].index = item
      })
      console.log(indexArr)
      console.log(backCards)
      this.flipCards = [...Cards, ...backCards] // 拼接数组
      console.log(this.flipCards)
    }
  }
})



// WEBPACK FOOTER //
// ./src/bus/index.js